import { useRoute, useRouter } from 'vue-router';

export function useRouting() {
  const route = useRoute();
  const router = useRouter();

  const routeLoggedIn = async () => {
    if (route.name === 'login') {
      await router.replace({ name: 'home' });
    }
  };
  const routeLoggedOut = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    if (route.name !== 'login') {
      await router.replace({
        name: 'login',
        params: { token }
      });
    }
  };

  return { routeLoggedIn, routeLoggedOut };
}
